import styled from 'styled-components';
import { fontSize_XS, fontSize_SM, fontSize_BASE } from '../../customFonts';
import { fontMedium } from '../../styles';

export const lightGreyShade = '#EBEBEB';
export const tableActionColor = '#f4f7fc';

interface Props {
    isBorderNone?: boolean;
}

export const CustomTable = styled.div<Props>`
    background-color: ${(props) => props.theme.standard.WHITE};
    border: ${(props: any) =>
        props.isBorderNone ? 'none' : `solid 1px ${props.theme.light_primary.LIGHT_QUATERNARY}`};
    border-radius: 12px;
    box-shadow: 0px 8px 16px rgba(44, 40, 40, 0.08);

    table {
        flex: 1;
        overflow: hidden;
        height: 100%;
        border-spacing: 0;
        border: 0;
        font-size: 16px;
        overflow-x: auto;
        width: 100%;

        thead,
        tbody {
            th,
            td {
                padding: 1rem;
                color: #45445c;
                ${fontSize_SM};
                letter-spacing: 0px;
                font-weight: 500;
                border-bottom: solid 1px ${lightGreyShade};
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
                border: solid 1px #f3f4f6;
                position: relative;

                &.sticky-left {
                    position: sticky;
                    left: 0;
                    top: 0;
                    border-right: solid 3px ${lightGreyShade};
                    z-index: 1;
                }

                &.sticky-right {
                    position: sticky;
                    right: 0;
                    top: 0;
                    border-left: solid 3px ${lightGreyShade};
                }
            }
        }

        thead {
            background-color: ${(props: any) => props.theme.warning.LIGHT_WARNING};
            position: sticky;
            top: -1px;
            z-index: 99;
            .sticky-left,
            .sticky-right {
                background-color: ${(props: any) => props.theme.warning.LIGHT_WARNING};
            }
            th,
            i {
                color: ${(props) => props.theme.primary.SECONDARY_THEME};
            }

            th {
                img {
                    padding: 6px;
                    cursor: pointer;
                    border: solid 1px #ccc;
                    border-radius: 4px;
                    background-color: white;
                }

                b {
                    padding-right: 1em;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

                .tooltip::before,
                .tooltip::after {
                    display: none;
                }

                .resizer {
                    display: inline-block;
                    width: 10px;
                    height: 100%;
                    position: absolute;
                    right: 0;
                    top: 0;
                }
            }
        }

        tbody {
            overflow-y: auto;

            > tr {
                &:hover,
                &.selected-row {
                    background-color: ${(props: any) =>
                        props.theme.warning.LIGHT_WARNING} !important;

                    .sticky-left,
                    .sticky-right {
                        background-color: inherit !important;
                    }
                }

                &:hover {
                    cursor: pointer;
                }

                &.highlighted-row {
                    background-color: ${(props: any) =>
                        props.theme.light_secondary.LIGHT_DARK} !important;

                    td {
                        border: ${(props: any) => props.theme.light_secondary.LIGHT_DARK};
                        border-bottom: solid 1px ${lightGreyShade} !important;
                    }

                    .sticky-left,
                    .sticky-right {
                        background-color: inherit !important;
                    }
                }
                td {
                    div {
                        overflow: hidden;
                        cursor: pointer;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }

                    input {
                        height: 32px;
                        background-color: ${(props) => props.theme.standard.WHITE};
                        border: solid 1px ${(props) => props.theme.light_primary.LIGHT_PRIMARY};
                        border-radius: 8px;
                        padding: 5px 10px;
                        ${fontMedium}
                        padding-right: 10px;
                        font-size: 1rem;
                        width: 100%;
                        color: ${(props: any) => props.theme.primary.primaryHeadingFontColor};
                        appearance: none;
                        -webkit-appearance: none;
                        -moz-appearance: none;
                        box-shadow: 0px 4px 16px #0000001a;
                        opacity: 1;

                        &::placeholder {
                            color: ${(props) => props.theme.primary.inputPlaceholderColor};
                            opacity: 1;
                        }

                        &:focus-visible {
                            outline: none;
                        }

                        &:hover,
                        &:focus {
                            border: solid 1px ${(props: any) => props.theme.primary.THEME};
                        }
                    }
                }

                &:nth-child(even) {
                    background-color: ${tableActionColor};
                    .sticky-left,
                    .sticky-right {
                        background-color: ${tableActionColor};
                    }
                }

                &:nth-child(odd) {
                    background-color: white;
                    .sticky-left,
                    .sticky-right {
                        background-color: white;
                    }
                }
            }
        }

        .empty-state {
            position: absolute;
            height: -webkit-fill-available;
            width: -webkit-fill-available;
        }
    }
`;

export const SecondaryCustomTable = styled(CustomTable)`
    table {
        tbody {
            th,
            td {
                overflow: unset;
            }
        }
        table thead tr th {
            background-color: ${(props: any) => props.theme.warning.LIGHT_WARNING};
            .postive {
                background-color: ${(props) => props.theme.success.DARK_SUCCESS};
            }
            .negative {
                background-color: ${(props) => props.theme.danger.DARK_DANGER};
            }
        }
    }
`;

export const BoxTableModal = styled.div`
  box-shadow: 0px 2px 10px #ccc;
  background-color: white;
  width: auto;
  padding: 12px;
  border-radius: 10px;

  .section-header {
    display: flex;
    justify-content: space-between;

    h5 {
      ${fontSize_BASE};
      color: ${(props: any) => props.theme.primary.SECONDARY_THEME};
      font-weight: bold;
    }

    i {
      color: ${(props: any) => props.theme.primary.THEME};
      cursor: pointer;
    }
  }

  .section-body {
    .asc-desc-btn-wrapper{
    button {
      b{
        color: black;
        font-weight: normal;
      }
    }  
  }
}



    h5 {
      ${fontSize_BASE};
      font-weight: bold;
    }

    .asc-desc-btn-wrapper {
      justify-content: space-between;
      display: flex;
      margin-bottom: 1.5rem;

      .asc-order {
        margin-right: 1rem;
      }

      .asc-order,
      .desc-order {
        border: solid;
        flex: 1;
        justify-content: center;
        border: 1px solid #bababa;
        border-radius: 4px;
        padding: 2px 5px;

        img {
          padding-right: 10px;
        }

        b {
          color: #3f4650;
          ${fontSize_XS};
          font-weight: 400;
          overflow: unset !important;
        }
      }
    }
  }

  .section-footer {
    display: flex;
    justify-content: space-between;
    padding-top: 16px;
  }
`;
